'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGlobals$0024 from "./presto.-Globals$.js";
var $p;
/** @constructor */
function $c_Lpresto_Render$() {
}
export { $c_Lpresto_Render$ as $c_Lpresto_Render$ };
$p = $c_Lpresto_Render$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Render$;
/** @constructor */
function $h_Lpresto_Render$() {
}
export { $h_Lpresto_Render$ as $h_Lpresto_Render$ };
$h_Lpresto_Render$.prototype = $p;
$p.cyM = (function(exp, other) {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((tk) => ((!(!exp.v(tk))) && (!(!other.v(tk))))));
});
$p.af8 = (function(role) {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((tk) => role.T7(tk)));
});
$p.a2m = (function(feature) {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((tk) => tk.zl(feature)));
});
$p.Ho = (function(exp, block) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapSignal(), $j_presto$002e$002dGlobals$0024.$m_Lpresto_Globals$().gS, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$50) => {
    if (_$50.k()) {
      return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
    } else {
      var arg1 = _$50.q();
      return ((!(!exp.v(arg1))) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some(block.aq()) : $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    }
  })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
var $d_Lpresto_Render$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Render$, "presto.Render$", ({
  Q9: 1
}));
export { $d_Lpresto_Render$ as $d_Lpresto_Render$ };
var $n_Lpresto_Render$;
function $m_Lpresto_Render$() {
  if ((!$n_Lpresto_Render$)) {
    $n_Lpresto_Render$ = new $c_Lpresto_Render$();
  }
  return $n_Lpresto_Render$;
}
export { $m_Lpresto_Render$ as $m_Lpresto_Render$ };
//# sourceMappingURL=presto.-Render$.js.map
